"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  Drafts: 'Drafts',
  Remote_Groups: 'Uploaded',
  Auth_Home_Create_Anonymous_Account_Title: "You may link it to your social network account anytime later",
  Auth_Home_Create_Anonymous_Account_Button: 'Create Guest Account',
  Auth_Home_Open_Social_Network_Account_Link: 'Sign in with social network account',
  Auth_Home_Select_Social_Network_Account: 'Sign in with one of social network accounts below',
  Gallery: 'Gallery',
  My_Collection: 'My Databases',
  Column_Type_Name_Text: 'Property',
  Column_Type_Name_Number: 'Number',
  Column_Type_Name_Long: 'Paragraph',
  Column_Type_Name_Boolean: 'On/Off',
  Input_Content_Here: 'Input Content Here',
  Tags: 'Tags',
  Title: 'Title',
  Subtitle: 'Subtitle',
  My_Database: 'My Databases',
  Edit: 'Edit',
  Create: 'Create',
  Data: 'Data',
  Icon: 'Icon',
  Add: 'Add',
  Cancel: 'Cancel',
  Confirm: 'Confirm',
  Please_Input_Description_Here: 'Input Description Here',
  Description: 'Description',
  Actions: 'Actions',
  Generic_Delete_Item_Title: 'Caution',
  Generic_Delete_Item_Message: 'Do you want to delete this item?',
  Search: 'Search',
  Search_Database: 'Search Databases',
  Click_Here_to_Add_New_Column: 'Click to add',
  Label: 'Label',
  Loading: 'Loading',
  Group_Follow_Confirm_Title: 'Do you want to follow this database?',
  Group_Follow_Confirm_Text: 'This database shortcut will be listed on your Favorite Databases page.',
  Group_Unfollow_Confirm_Title: 'Do you want to unfollow this database?',
  Group_Unfollow_Confirm_Text: 'The database shortcut from your Favorite Databases page will be deleted.',
  Item_Follow_Confirm_Title: 'Do you want to follow this item?',
  Item_Follow_Confirm_Text: 'This item shortcut will be listed on your Favorite Items page.',
  Item_Unfollow_Confirm_Title: 'Do you want to unfollow this item?',
  Item_Unfollow_Confirm_Text: 'The item shortcut from your Favorite Items page will be deleted.',
  Followed_Databases: 'Favorite Databases',
  Followed_Items: 'Favorite Items',
  Item_Edit_Open_Desc_Text: 'Edit Description',
  Item_Edit_Open_Gallery_Text: 'Edit Gallery',
  Edit_Label: 'Edit Label',
  Edit_Content: 'Edit Content',
  Rows_Edit_Add_New_Data: 'Add Data',
  Column_Edit_For_Boolean_Switch_Reminder: 'On/Off',
  Close: 'Close',
  Copy: 'Copy',
  Copied: 'Copied',
  Open_External_Link: 'Open External Link',
  Error_on_Open_External_Link: 'Error occurred on openning an external link.',
  No_Data: 'No data',
  Delete: 'Delete',
  Terms_of_Use: 'Terms of Use',
  Privacy_Policy: 'Privacy Policy',
  Upload: 'Upload',
  Ref_Row_Not_Found_Title: 'Data Not Found',
  Ref_Row_Not_Found_Subtitle: 'The data may be deleted by its owner.',
  Filter_No_Option: 'There is no filter option',
  Remote_Items_No_Data: 'There is no record in the database',
  Settings: 'Settings',
  Link_to_Google: 'Link to Google',
  Link_to_Facebook: 'Link to Facebook',
  Link_to_Accounts: 'Link to social network accounts',
  Google: 'Google',
  Facebook: 'Facebook',
  Link_to_Accounts_Reminder: 'Make your account recoverable in case you lost it.',
  Unknown_Username: 'Unknown Username',
  Account_Linked: 'Account is Linked',
  Sign_Out: 'Sign out',
  Auth_Home_Creating_Anonymous_Account: 'Processing',
  Group_Edit_Set_Public_Title: 'Set this database public',
  Public: 'Public',
  Group_Edit_Set_Public_Caption: 'If you switched it off, this database will be unlisted. However, the database is still accessible by searching database ID on search page.',
  Input_Tag_Here: 'Input tag here',
  Group_Edit_Tags_Caption: 'Users can search databases by tags you input here.',
  Filter_Add_Custom_Query: 'Add more queries',
  Row_Edit_Filterable_Switch_Caption: "If you switched it off, all data under this row will not be available for filtering",
  Row_Edit_Filterable_Switch_Title: 'Available for Filter',
  Row_Edit_Filterable_Switch_Name: 'Available',
  Label_Edit_Existing_Options: 'Existing Labels',
  Row_Settings: 'Row Settings',
  Input_Any_Label: 'Input label here',
  Sort: 'Sort',
  Remark: 'Remark',
  Item_Edit_Open_Remark_Text: 'Edit Remark',
  Done: 'Done',
  Remote_Items_Contribute_Item: 'Help adding new content',
  Remote_Items_Contribute_Reminder: 'The data is accessible/functional to you ONLY until it got approved by the database owner.',
  Details: 'Details',
  Got_It: 'Got it',
  Remote_Groups_Delete_Title: 'Do you want to delete the database?',
  Remote_Groups_Delete_Msg: 'All your own data in this database will be deleted forever.',
  Mandatory_Title_Placeholder: 'Title (mandatory)',
  Pending: 'Pending',
  Rejected: 'Rejected',
  Approved: 'Approved',
  Reject: 'Reject',
  Approve: 'Approve',
  Remote_Item_Reject_Title: 'Do you want to reject this data?',
  Remote_Item_Reject_Msg: "The data will be hidden until it's author resubmit the request.",
  Remote_Item_Approve_Title: 'Do you want to approve this data?',
  Remote_Item_Approve_Msg: 'The data will be accessible/functional in your database.',
  Item_Edit_Open_Adv_Settings: 'Advance Settings',
  Basic: 'Basic',
  Advanced: 'Advanced',
  Item_Edit_Menu_Excel: 'Dataset',
  Item_Edit_Menu_Settings: 'Settings',
  Item_Edit_Group_Owner_Editable_Title: 'Can database owner edit the data?',
  Item_Edit_Group_Owner_Editable_Msg: '[Works ONLY for data is attached to a database that is NOT belonging to you] If you choose YES, the database owner has full control of your data (except delete), otherwise, they can detach your data from their database only.',
  Editable: 'Editable',
  Detach: 'Detach',
  Remote_Item_Detach_Title: 'Do you want to detach this row of data?',
  Remote_Item_Detach_Msg: 'This row of data will be detached from current database and will be available to attach to another database.',
  Remote_Item_Delete_Title: 'Do you want to delete the data?',
  Remote_Item_Delete_Msg: 'The data will be NOT recoverable.',
  Owner: 'Owner',
  My_Contributions: 'My Contributions',
  Mine: 'Mine',
  Detached: 'Detached',
  Remote_Item_Review_Reminder_Group_Owner_Can_Edit: 'The author granted you the edit permission',
  Input_Number_Here: 'Input Number Here',
  Options_With_Same_Label: 'Options with the same label',
  Group_Edit_Set_Receive_Notification_Contribution_Title: 'Receive Notifications',
  Group_Edit_Set_Receive_Notification_Contribution_Reminder: 'Receive Notifications',
  Group_Edit_Set_Receive_Notification_Contribution_Msg: 'If yes, you will receive notifications for operations that affect this database.',
  Remote_Groups_Search_Empty_Text: 'No Search Result',
  Remote_Groups_Placeholder: 'Create your first database',
  Anonymous_Sign_Out_Btn: 'Delete Account',
  Anonymous_Sign_Out_Title: 'Do you want to delete the guest account?',
  Anonymous_Sign_Out_Msg: 'The guest account that without linking to any social accounts will be deleted forever.',
  Review: 'Review',
  Remote_Item_Review_Not_Pending_Reminder: 'The data is not pending state. It may be caused by the cancellation/modification of its owner',
  Generic_Incorrect_Number_Input: 'Incorrect number input',
  View: 'View',
  Click_Enter_Key: "Click enter key",
  Group_Edit_Tag_Not_Saved: 'Click return key',
  Push_Notification_Group_Has_Pending: "Your database (%{title}) has new data added and waiting for your approval.",
  Push_Notification_Group_Has_Pending_With_Nickname: "Your database (%{title}) has new data added waiting for your approval.",
  Push_Notification_Item_Got_Reviewed: "Your data (%{title}) was reviewed by database owner.",
  Push_Notification_Item_Got_Approved: "Your data (%{title}) was approved by database owner.",
  Push_Notification_Item_Got_Rejected: "Your data (%{title}) was rejected by database owner.",
  Push_Notification_Item_Got_Deleted: "Your database (%{group_title}) has data (%{item_title}) got deleted by its owner.",
  Generic_Error_Message: "Oops, something unusual happened. Please contact our development if this keeps happening.",
  Item_Edit: 'Edit Data',
  Item_Create: 'Create Data',
  Group_Edit: 'Edit Database',
  Group_Create: 'Create Database',
  Tag_Sign: '#',
  Time_Gap_Last_Edit_Day: 'Edited: %{day}d ago',
  Time_Gap_Last_Edit_Hour: 'Edited: %{hour}h ago',
  Time_Gap_Last_Edit_Minute: 'Edited: %{minute}m ago',
  Time_Gap_Last_Edit_Unknown: 'Last edit unknown',
  Swipe_Down_to_Close: 'Swipe down to close',
  Click_to_Open_Group: 'Clik to open the database',
  Attach_to_Group: 'Attach to a database',
  Remote_Item_Attach_Title: 'Do you want to attach it to database: %{group_title}',
  Remote_Item_Attach_Msg_Owner: 'This is your own database, it will be public immediately.',
  Remote_Item_Attach_Msg_Not_Owner: 'It is going to be reviewed by database owner.',
  Share: 'Share',
  Group_Title_Mandatory: 'Database Title (Mandatory)',
  Item_Title_Mandatory: 'Data Title (Mandatory)',
  Dataset_Title: 'Dataset Title',
  Group_ID_Share_Text: 'Share the CoDB database ID: %{id}. It is also accessible on web: %{link}',
  Group_Edit_Auto_Approve_Title: 'Approve contributions automatically',
  Group_Edit_Auto_Approve_Flag: 'Auto Approve',
  Group_Edit_Auto_Approve_Caption: 'If yes, contributions added to this database will be public immediately.',
  Check: 'Check',
  Push_Notification_Group_Has_Approved: "Your database (%{title}) has new data added.",
  Push_Notification_Group_Has_Approved_With_Nickname: "%{nickname} added data to your database (%{title}). Click to view details",
  Filter_Add_Custom_Query_Short_Text: "Search words",
  Filter_Add_Custom_Query_Number: "Add more queries",
  Column_Type_Name_Relation: 'Connect',
  Column_Edit_Relation_Choose_Target_Caption: 'Choose a data that has relation that match your dataset title',
  Column_Edit_Relation_Current_Selected_Target_Caption: 'Selected data',
  Column_Edit_Relation_No_Item_Selected_Reminder: 'Choose an item below',
  Invalid_Input: 'Invalid',
  Filter_Add_Custom_Query_Relation: 'Add a query to the "Connected" data',
  Filter_User_Input_Relation_Action_Equal: 'Equal (=)',
  Filter_User_Input_Relation_Action_Include: 'Includes text',
  Filter_User_Input_Relation_Action_Larger: 'Larger than (>)',
  Filter_User_Input_Relation_Action_Equal_Larger: 'Larger or equal (>=)',
  Filter_User_Input_Relation_Action_Smaller: 'Less than (<)',
  Filter_User_Input_Relation_Action_Equal_Smaller: 'Less or equal (<=)',
  Filter_User_Input_Relation_Row_Compare_Placeholder: 'Criteria',
  Dataset_Label: 'Dataset Label',
  Filter_User_Input_Relation_Action_Switched_On: 'Yes',
  Filter_User_Input_Relation_Action_Switched_Off: 'No',
  Column_Edit_For_Relation_Empty_List_Reminder: 'Options list is empty. Please be noted that only approved data in the same database are connectable currently.',
  Remote_Items_No_Data_Filtered: 'Filtered result is empty',
  Remote_Groups_Search_Box_Reminder: 'Search by database names or tags',
  Remote_Items_Contribute_Reminder_Auto_Approve: 'Since the database owner enables the auto-approve feature, your contribution will be public right after your submission.',
  Remote_Item_Review_Reminder_Group_Owner_Can_Not_Edit: 'The author did not grant you the edit permission',
  Followed_Group_Delete_Confirm_Title: 'Do you want to delete the followed database bookmark?',
  Item_Edit_Group_Owner_Editable_Disabled_Msg: 'This setting can not be modified after the data is in approved or pending status.',
  Sign_Out_Title: 'Do you want to sign out?',
  Input_Nickname_Here: 'Input nickname here',
  Nickname: 'Nickname',
  App_Title: 'Co Database',
  App_Slogan: 'Tailor-make Online Databases',
  Datasets: 'Datasets',
  Remote_Item_Resubmit: 'Resubmit',
  Remote_Item_Resubmit_Title: 'Do you want to re-submit the data to the current database?',
  Remote_Item_Resubmit_Subtitle_Auto_Approve: 'Your data will be public right after the submission.',
  Remote_Item_Resubmit_Subtitle_Need_Review: 'The database owner asked for review of new added data.',
  Auth_Credential_Already_In_Use: 'This credential is already associated with a different user account.',
  Followed_Item_Delete_Confirm_Title: 'Do you want to delete the followed data bookmark?',
  Back_to_Group: 'Database',
  Remote_Item_Anonymous_Owner: 'Anonymous',
  Remote_Group_Anonymous_Owner: 'Anonymous',
  Time_Gap_Light_Day: '%{day} Days',
  Time_Gap_Light_Hour: '%{hour} Hours',
  Time_Gap_Light_Minute: '%{minute} Minutes',
  Time_Gap_Light_Unknown: 'N/A',
  Remote_Item_Review_Action_Error: 'Failed to review the data',
  Criterion: 'Criterion',
  Input_Search_Words_Here: 'Input Search Words Here',
  Item_Share_Text: 'Access the CoDB item here: %{link}',
  Promote_App_Text: 'Get the App for tons of more features',
  Link_to_App_Text: 'Already installed App?',
  Link_to_App_Btn_Text: 'Open App',
  Remote_Group_Search_Fetch_More_Btn: 'Fetch more',
  Group_Edit_Set_Public_Unsecure_Caption: 'You should NEVER store any sensitive data on this app. Be noted that users are able to access to a database by its id directly, no matter the database is set to public or not.',
  Settings_Join_Slack_Title: 'Join us on Slack',
  Settings_Join_Slack_Subtitle: "Bugs report, suggestions, discussion and more",
  Link_Open_Failed_Msg: 'Failed to open the link',
  Contact_Us_Caption: 'Contact us',
  Column_Display_Unknown_Type_Reminder: 'Unknown type, please upgrade your app to latest version',
  Item_Contribute: 'Contribute',
  Remote_Items_Contribute_Short_Reminder_Auto_Approve: 'Approved automatically',
  Remote_Items_Contribute_Short_Reminder: 'Needed Review',
  Remote_Items_Search_Box_Reminder: 'e.g. Any text or property::value',
  Column_Edit_Relation_Search_Box_Reminder: 'Search database row here',
  View_Action_Sheet_Title: 'Select Displaying View',
  Item_View_Regular_View: 'Regular View',
  Item_View_Simple_View: 'Simple View',
  Item_View_Only_Title_View: 'Only Title',
  Sort_Action_Sheet_Title: 'Manage sort options on database settings page',
  Items_Sort_Reserved_Edit_At: 'Last Edit',
  Items_Sort_Reserved_Create_At: 'Created At',
  Items_Sort_Reserved_Title: 'Title',
  Items_Sort_Reserved_Subtitle: 'Subtitle',
  Row_Edit_Sortable_Switch_Title: 'Available for Sort',
  Row_Edit_Sortable_Switch_Caption: "If you switched it off, all data under this row will not be available for sorting",
  Row_Settings_Edit_Advanced_Settings: 'Adv. Settings',
  Column_Edit_Relation_Selected_Count: 'Currently Selected: %{count}',
  Column_Edit_Relation_Selected_None: 'No Item Selected',
  Group_Edit_Hidden_Labels_Title: 'Hide specific labels in filter selection',
  Group_Edit_Input_Label_Here: 'Input label here',
  Group_Edit_Hidden_Labels_Caption: '',
  Column_Type_Name_Rate: 'Rate',
  Rows_Edit_Add_All_Caption: '*Long press to add all rows with existing labels',
  Group_Edit_Hidden_Sort_Labels_Title: 'Hide specific labels in sort selection. Be noted that built-in properties are excluded: title, subtitle, create date, edit date, etc.',
  Group_Edit_Quick_Filter_Title: 'Quick Filter',
  Group_Edit_Quick_Filter_Caption: 'Quick Filter displays at the top of data list.',
  Group_Quick_Filter: 'Open quick filter settings page',
  Quick_Filter_Edit_Page_Title: 'Edit Quick Filter',
  Quick_Filter_Empty_Reminder: 'No filter option',
  Advance_Filter_Short: 'Adv. Filter',
  Manage: 'Manage',
  Reset: 'Reset',
  Optional_Input: 'Optional',
  Group_Edit_Sort_Label_Title: 'Sort Data',
  Group_Edit_Sort_Label_Selection: 'Open sort settings page',
  Group_Edit_Sort_Label_Caption: 'You can show/hide sort options. By default all rows are sortable.',
  Group_Edit_Adv_Filter_Title: 'Edit Advance Filter',
  Group_Edit_Adv_Filter_Selection: 'Open advance filter settings page',
  Group_Edit_Adv_Filter_Caption: 'If you want to hide specific rows only, go to that item edit page to hide rows you want.',
  Explore: 'Explore',
  Popular: 'Popular',
  No_Options_Reminder: 'There are no options available.'
};